<ng-template #templateRef
             let-columns>
  @if (tableSettings.hasHeaders) {
    <tr>
      @if (tableSettings.selectionMode) {
        <th class="sc-selectable-column">
          @if (canSelect) {
            <p-checkbox [binary]="true"
                        [ngModel]="allCheckBoxState$ | async"
                        (onChange)="stateService.togglePageSelection($event)">
            </p-checkbox>
          }
        </th>
      }
      @if (tableSettings.reordering?.separateColumn) {
        <th class="sc-reordering-column">
        </th>
      }
      @for (column of columns; track trackByFunc($index, column)) {
        <th pReorderableColumn
            [ngClass]="{ 'sc-row-reorder-column': column.isReorderable, 'sc-reorder-table-header': canReorderRows, 'justify-content-center': column.settings.centered }"
            [pReorderableColumnDisabled]="!tableSettings.reorderableColumns"
            pResizableColumn
            [pResizableColumnDisabled]="!tableSettings.resizableColumns"
            [pSortableColumn]="column.sortableFieldPath"
            [pSortableColumnDisabled]="!column.sortable || canReorderRows"
            [ngStyle]="column.headerStyle">
          @if (column.sortable && !canReorderRows) {
            <p-sortIcon [field]="column.sortableFieldPath"></p-sortIcon>
          }
          <span scOverflowTooltip>{{ column.header }}</span>
          @if (column.settings.helpTemplateRef; as helpTemplateRef) {
            <a class="ml-2">
              <p-popover #overlayPanel
                         styleClass="sc-overlay-panel"
                         appendTo="body">
                <ng-template #content>
                  <ng-container *ngTemplateOutlet="helpTemplateRef()"></ng-container>
                </ng-template>
              </p-popover>
              <i class="fas fa-question-circle"
                 (click)="overlayPanel.show($event)"></i>
            </a>
          }
        </th>
      }
      @if (hasActionsColumn()) {
        <th class="sc-actions-column sc-actions-column-{{tableSettings.actionsCount}}">
        </th>
      }
    </tr>
  }
  @if (tableSettings.hasFilters && !canReorderRows) {
    <tr class="sc-table-filter-row">
      @if (tableSettings.selectionMode) {
        <th class="sc-selectable-column">
        </th>
      }
      @for (column of columns; track trackByFunc($index, column)) {
        <th [ngStyle]="column.headerStyle">
          @if (column.filterTemplate) {
            <ng-container *ngTemplateOutlet="column.filterTemplate; context: {$implicit: column}"></ng-container>
          }
        </th>
      }
      @if (hasActionsColumn()) {
        <th class="sc-actions-column sc-actions-column-{{tableSettings.actionsCount}}">
        </th>
      }
    </tr>
  }
</ng-template>